import _ from 'lodash';
import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../helpers/reselectHelpers';
import {IntegrationTypeCategoriesEnum} from '../../../models/api/integrationTypesModel';
import {AppState} from '../../../store/appState';
import {
  getAlphabeticalSortedIntegrationTypes,
  getIsIntegrationTypesLoading,
} from '../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsCategoryPage} from './settingsAppsCategoryPage';

/*
 * Props.
 */

interface SettingsAppsCategoryPageContainerProps {
  category: IntegrationTypeCategoriesEnum;
}

/*
 * Selectors.
 */

function getCategory(_state: AppState, props: SettingsAppsCategoryPageContainerProps) {
  return props.category;
}

export const getIntegrationTypesForCategory = createSelector(
  [getCategory, getAlphabeticalSortedIntegrationTypes],
  (category, integrationTypes) =>
    _(integrationTypes)
      .filter((integrationType) => integrationType.categories.includes(category))
      .value(),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsCategoryPageContainerProps>()(() => ({
  integrationTypes: getIntegrationTypesForCategory,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
}));

export const SettingsAppsCategoryPageContainer = connect(mapStateToProps)(SettingsAppsCategoryPage);
